import AVS from "./../lib/AVS";
import { AVSWrapperUtil } from "./AVSWrapperUtil";
import { AlexaCommon } from "./Common";


const AMAZON_ERROR_CODES = require("../lib/AmazonErrorCodes.js");
const autoBind = require("auto-bind");

const httpMessageParser = require('http-message-parser');

// With ES6,TypeScript etc
// import Artyom from './artyom.js';
// import keyboardJS from 'keyboardjs';

class AVSWrapper {
  constructor(avs) {
    this.avs = avs;
    this.testMediaRecorder = null;
    this.recordedBlobs = [];

    autoBind(this);
  }
  
  recording = false;

  login() {
    return new Promise((resolve, reject) => {
      console.log(AlexaCommon.settings);
      const authUrl = AlexaCommon.buildAuthCodeUrl(AlexaCommon.settings);
      window.location.assign(authUrl);
      resolve(authUrl);
    });
  }

  getProfileLogin() {
    return new Promise((resolve, reject) => {
      const authUrl = AlexaCommon.buildGetProfileUrl(
        AlexaCommon.getProfileSettings
      );
      window.location.href = authUrl;
    });
  }

  logout() {
    return this.avs.logout().then(() => {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      window.rzevent.triggerEvent(window.rzevent.EventTypes.LOGOUT);
      this.avs.emit(AVS.EventTypes.LOGOUT);
    });
  }

  doLogout() {
    window.rzevent.triggerEvent(window.rzevent.EventTypes.DO_LOGOUT);
  }

  startRecording() {
    return this.avs.startRecording();
  }
  /**
   * @description
   * 1. Event emit No_response
   */
  cancelRecording() { 
    var self = this;
    localStorage.removeItem('dialogRequestId');
    self.avs.stopRecording(true).then(dataView => {
      self.avs.emit(AVS.EventTypes.NO_RESPONSE);
      self.avs.player.emptyQueue().catch(error => {
        console.error(error);
      });
    });
  }

  /**
   * @description
   * When user stop recording his voice to be ready to send vocal data to amazon.
   * 1. consolidate vocal data -> dataview
   * 2. HTTP to AVS API with dataview
   * 3. Get AVS Response
   * 4. Enqueue AVS player queue
   * 5. Push Back AVS Card array
   * 6. Event emit 1.card change(UI for refresh home card list) 2. SPEAKING (For WPF to close popup) 3.show card
   */
  stopRecording() {
    var self = this;
    return self.avs.stopRecording().then(dataView => {
      self.avs.player.emptyQueue().catch(error => {
        console.error(error);
      });

      self.avs
        .sendAudio(dataView)
        .then(({ xhr, response }) => {
          console.log('avs v0 ' + xhr + 'resp ' + JSON.stringify(response));
          if (self.avs.isRecording()) { return; }
          // audios is empty when response header is null
          let audios = AVSWrapperUtil.parseAlexaAudioResponse(xhr, response);
          let cardPayload = AVSWrapperUtil.parseAlexaCardsInfo(xhr, response);
          let cardOption = AlexaCommon.payloadToCardOption(cardPayload);
          let card = self.avs.cardManager.createCard(cardOption);
          let expectSpeech = AVSWrapperUtil.parseAlexaListenDirective(xhr, response);
          let promises = [];
          audios.forEach(audio => {
            promises.push(self.avs.player.enqueue(audio));
            promises.push(self.avs.cardManager.addCardAsync(card));
          });
          if (promises.length) {
            Promise.all(promises).then(() => {
              window.rzevent.triggerEvent(
                window.rzevent.EventTypes.CARD_CHANGE,
                card
              );
              self.avs.emit(AVS.EventTypes.SPEAKING);
              self.avs.emit(AVS.EventTypes.SHOW_CARD, card);
              if (
                expectSpeech != null &&
                expectSpeech.timeoutIntervalInMillis != "undefined"
              )
                self.avs.emit(AVS.EventTypes.EXPECT_SPEECH, expectSpeech);
              self.avs.player.playQueue();
            });
          }
          else {
            self.avs.emit(AVS.EventTypes.NO_RESPONSE);
          }
        })
        .catch(error => {
          console.error("error while sending audio to avs "+ JSON.stringify(error));
            self.avs._destroyStream();
            self.avs.emit(AVS.EventTypes.NO_RESPONSE); //incase any error just close popup
        });
    });
  }

  sendBlob(blob) {
    const xhr = new XMLHttpRequest();
    const fd = new FormData();

    fd.append("fname", "audio.wav");
    fd.append("data", blob);

    xhr.open("POST", "http://localhost:5555/audio", true);
    xhr.responseType = "blob";

    xhr.onload = event => {
      if (xhr.status == 200) {
        console.log(xhr.response);
        //const responseBlob = new Blob([xhr.response], {type: 'audio/mp3'});
      }
    };

    xhr.send(fd);
  }

  clearURLHash() {
    window.location.hash = "";
  }

  triggerRefreshCardEvent(card = {}) {
    window.rzevent.triggerEvent(window.rzevent.EventTypes.RENDER_CARD, card);
  }
  stopPlay() {
    window.avs._destroyStream();
    window.avs.player.stop();
  }

  /**
   * [IMPORTANT function]
   * Case 1 - ideal: can get new access_token and refresh_token and update avs obj and localstorage.
   * Case 2: can get new access_token but cannot set access_token.
   * Case 3: can get new refresh_token but cannot set refresh_token
   * Case 4: cannot get new access_token or refresh_token
   */
  async useRefreshTokenToUpdateAccessToken() {
    try {
      const res = await AlexaCommon.getTokenFromRefreshToken(localStorage.getItem('refreshToken'));
      try {
        //Update localstorage and UI avs object
        await window.avs.setToken(res.access_token)
        localStorage.setItem("token", res.access_token);
        window.avs.emit(AVS.EventTypes.TOKEN_SET);
        // window.avs.emit(AVS.EventTypes.REFRESH_TOKEN_SET);
        window.rzevent.triggerEvent(window.rzevent.EventTypes.REQUEST_TELL_WPF_NEW_ACCESS_TOKEN, res.access_token);
        //#Case 1#
      } catch {
        //#Case 2#
        window.avs.emit(AVS.EventTypes.UPDATE_ACCESS_TOKEN_FAILED);
        AlexaCommon.consoleLogDataUIFatalError("Token update failed", "Case 2");

      }
      try {
        //Update localstorage and UI avs object
        await window.avs.setRefreshToken(res.refresh_token)
        localStorage.setItem("refreshToken", res.refresh_token);
        window.avs.emit(AVS.EventTypes.REFRESH_TOKEN_SET);
        //#Case 1#
      } catch {
        window.avs.emit(AVS.EventTypes.UPDATE_REFRESH_TOKEN_FAILED);
        AlexaCommon.consoleLogDataUIFatalError("Token update failed", "Case 3");
        //#Case 3#

      }
    } catch(ex) {
      window.avs.emit(AVS.EventTypes.UPDATE_TOKEN_FAILED);
      AlexaCommon.consoleLogDataUIFatalError("Token update failed", "Case 4");
      //#Case 4#
    };
  }

  setToken() {
    let token = localStorage.getItem("token");
    if (token != null) window.avs.setToken(token);
  }

  setSynapseToken(synapseToken) {
    console.log('synapse token set:'+ synapseToken);
    localStorage.setItem('synapseToken', synapseToken);
    window.rzevent.triggerEvent(window.rzevent.EventTypes.RESPONSE_SYNAPSE_TOKEN, synapseToken);
  }

  navigateTo(page = AlexaCommon.Pages.HOME) {
    window.rzevent.triggerEvent(window.rzevent.EventTypes.NAVIGATE_TO, page);
  }

  setShortcut(data) {
    window.rzevent.triggerEvent(window.rzevent.EventTypes.SHORTCUT_SET, data);
  }
  setalexaJson(data) {
    AlexaCommon.setalexaJson(data);
    AlexaCommon.consoleLogDataFromSynpase(
      "Receive synapse data setting strObj",
      JSON.stringify(data)
    );
    window.rzevent.triggerEvent(
      window.rzevent.EventTypes.RESPONSE_SYNAPSE_DATA,
      data
    );
  }

  /**
   *
   * @param {Number} data
   * @example
   * Undefined = 0,
   * English = 1,
   * Chinese_Simplified = 2,
   * Chinese_Traditional = 3,
   * French = 4,
   * Korean = 5,
   * Japanese = 6,
   * German = 7,
   * Russian = 8,
   * Spanish = 9,
   * Portuguese = 10
   */
  setLanguage(data) {
    console.log("language from ui:" + data);
    window.rzevent.triggerEvent(
      window.rzevent.EventTypes.RESPONSE_LANGUAGE_CHANGE,
      data
    );
  }

  /**
   *
   * @param {Number} data
   * @example
   * Lifestyle = 1,
   * Dark = 2
   */
  setTheme(data) {
    console.log("theme from ui:" + data);
    window.rzevent.triggerEvent(
      window.rzevent.EventTypes.RESPONSE_THEME_CHANGE,
      data
    );
  }

  /**
   * @param {Boolean} data
   * @emits EventTypes.SYNAPSE_ISGUEST_CHANGE
   */
  setSynapseIsGuestStatus(data) {
    window.rzevent.triggerEvent(
      window.rzevent.EventTypes.SYNAPSE_ISGUEST_CHANGE,
      data
    );
  }

  deviceChanged() {
    console.log("device changed");
    window.rzevent.triggerEvent(window.rzevent.EventTypes.DEVICE_UPDATED, null);
  }

  /**
   * @param {string} activeDevice
   * @description call it for every browser sessions
   */
  getConstraintForActiveMicInput(activeDevice) {
    return new Promise((resolve, reject) => {
      if (!activeDevice) {
        reject();
      }
     let deviceId;
     let activeDeviceId;
      navigator.mediaDevices
      .enumerateDevices().then(d=>{
        if(d.length > 0)
        {
          d.forEach(element => {
            if (element.kind === "audioinput" && element.deviceId === "default"){
              activeDeviceId = element.deviceId;
            }
            if (element.kind === "audioinput" &&
              element.deviceId !== "communications" &&
              ((activeDevice === "default" &&
                element.deviceId === activeDevice) ||
                element.label.includes(activeDevice))) {
              console.log(element);
              deviceId = element.deviceId;
            }
          });         
        }
        let constraints = {
          audio: { deviceId: deviceId ? { exact: deviceId } : activeDeviceId }
        };
        
        if (deviceId == 'default'){
          deviceId = this.getDeviceIdForDefault(d);
          if(deviceId != 'default') {
            constraints = {
              audio: { deviceId: deviceId ? { exact: deviceId } : activeDeviceId }
            };
          }
          else {
            constraints ={
              audio: true
            }
          }
        } 
        console.log('getConstraintForActiveMicInput'+ JSON.stringify(constraints))
        resolve(constraints);
        
      }) .catch((e) => {
        window.avs.setMicDetected(false);
        reject(e);
      });
      
     });
  }

 
  getDeviceIdForDefault(d){
    let deviceId = 'default';
    let groupId;
    if(d.length > 0)
    {
      for (let element of d) {
        if (element.kind === "audioinput" && element.deviceId === "default"){
          groupId = element.groupId;
        }
        if (element.kind === "audioinput" && element.groupId === groupId && element.deviceId != 'default' && element.deviceId != 'communications'){
          deviceId = element.deviceId;
          break;
        }
      }       
    }
    return deviceId;
  }

  /**
   * 
   */
  forceCloseAllNotificationDialog(){
      window.rzevent.triggerEvent(window.rzevent.EventTypes.RESPONSE_CLOSE_ALL_DIALOG);
      AlexaCommon.consoleLogDataUIImportantInfo("WPF ask to close all dialog.");
  }

  changeWakeWordStatus(data){
    window.rzevent.triggerEvent(window.rzevent.EventTypes.WAKE_WORD_STATUS_CHANGE,(data == 'true'));
    AlexaCommon.consoleLogDataUIImportantInfo("WPF ask to change wake word feature status.", (data == 'true'));
  }

  updateAudioDeviceDropDownEnableStatus(data){
    window.rzevent.triggerEvent(window.rzevent.EventTypes.RESPONSE_AUDIO_DEVICE_ENABLE_STATUS,(data.toUpperCase() == 'true'.toUpperCase()));
    AlexaCommon.consoleLogDataUIImportantInfo("WPF update audio device dropdown status.", (data.toUpperCase() == 'true'.toUpperCase()));
  }

  sendWakeWordAudio(data){
    var self = this;
    self.avs.stopRecording().then(dataView => {
      self.avs.player.emptyQueue().catch(error => {
        console.error(error);
      });
    });
    this.avs.sendWakeWordAudio(data)
    .then(({ xhr, response }) => {
      console.log('avs v0 ' + xhr + 'resp ' + JSON.stringify(response));
      if (self.avs.isRecording()) { return; }
      // audios is empty when response header is null
      let audios = AVSWrapperUtil.parseAlexaAudioResponse(xhr, response);
      let cardPayload = AVSWrapperUtil.parseAlexaCardsInfo(xhr, response);
      let cardOption = AlexaCommon.payloadToCardOption(cardPayload);
      let card = self.avs.cardManager.createCard(cardOption);
      let expectSpeech = AVSWrapperUtil.parseAlexaListenDirective(xhr, response);
      let promises = [];
      audios.forEach(audio => {
        promises.push(self.avs.player.enqueue(audio));
        promises.push(self.avs.cardManager.addCardAsync(card));
      });
      if (promises.length) {
        Promise.all(promises).then(() => {
          window.rzevent.triggerEvent(
            window.rzevent.EventTypes.CARD_CHANGE,
            card
          );
          self.avs.emit(AVS.EventTypes.SPEAKING);
          self.avs.emit(AVS.EventTypes.SHOW_CARD, card);
          if (
            expectSpeech != null &&
            expectSpeech.timeoutIntervalInMillis != "undefined"
          )
            self.avs.emit(AVS.EventTypes.EXPECT_SPEECH, expectSpeech);
          self.avs.player.playQueue();
        });
      }
      else {
        self.avs.emit(AVS.EventTypes.NO_RESPONSE);
      }
    })
    .catch(error => {
      console.error("error while sending audio to avs "+ JSON.stringify(error));
        self.avs.emit(AVS.EventTypes.NO_RESPONSE); //incase any error just close popup
    });
  }
}
export default AVSWrapper;
